import React from 'react'

export const Title = ({children}) => (
    <h1 className="title">{children}</h1>
)

